const API = {
  // common
  openLinkInBrowser: `common.openLinkInBrowser`,
  screenshot: `common.screenshot`,
  log: `common.log`,
  appReady: `common.appReady`,
  isDogfoodBuild: `common.isDogfoodBuild`,

  // accessibility
  getChatDisplaySize: 'accessibility.getChatDisplaySize',

  // auth
  getNak: `auth.getNak`,
  getZak: `auth.getZak`,
  getPak: `auth.getPak`,
  refreshPak: `auth.refreshPak`,

  // webview
  closeWebview: `webview.closeWebview`,
  confirmDestroy: `webview.confirmDestroy`,
  sendMessage: `webview.send`,
  replyNotification: `webview.replyNotification`,
  getPendingRequests: `webview.getPendingRequests`,
  saveWebContent: `webview.saveWebContent`,
  restoreWebContent: `webview.restoreWebContent`,
  webviewResize: `webview.resize`,
  webviewGetRect: `webview.getRect`,
  getPerformanceMetrics: `webview.getPerformanceMetrics`,
  getWebviewId: `webview.getWebviewId`,
  recreate: `webview.recreate`,
  setZoomFactor: `webview.setZoomFactor`,
  getZoomFactor: `webview.getZoomFactor`,
  addShortcutListener: `webview.addShortcutListener`,
  removeShortcutListener: `webview.removeShortcutListener`,
  readyForPushNotification: `webview.readyForPushNotification`,
  queryHotkey: `webview.queryHotkey`,

  // filesystem
  openSysDlgSelectPath: `filesystem.openSysDlgSelectPath`,
  openSysDlgSelectDirectory: `filesystem.openSysDlgSelectDirectory`,
  saveAsFile: `filesystem.saveAsFile`,
  openFilePicker: `filesystem.openFilePicker`,
  getFileAbility: `filesystem.getFileAbility`,
  getFileInfo: `filesystem.getFileInfo`,
  read: `filesystem.read`,
  openSysFileExplorer: `filesystem.openSysFileExplorer`,
  checkPathExists: `filesystem.checkPathExists`,
  savePathIdToDB: `filesystem.savePathIdToDB`,
  openFileBySystemApp: `filesystem.openFileBySystemApp`,

  // permissions
  queryPermission: `permissions.queryPermission`,
  resetPermission: `permissions.resetPermission`,

  // platform
  getSystemParam: `platform.getSystemParam`,
  getClientSetting: `platform.getClientSetting`,

  // theme
  getEmojiReactionSkin: 'theme.getEmojiReactionSkin',

  // download
  startDownload: `download.startDownload`,
  pauseDownload: `download.pauseDownload`,
  resumeDownload: `download.resumeDownload`,
  cancelDownload: `download.cancelDownload`,
  getDownloadInfo: `download.getDownloadInfo`,

  // clipboard
  clipboardRead: `clipboard.read`,
  clipboardWrite: `clipboard.write`,

  // history
  historyPush: `history.push`,
  historyDeleteItem: `history.deleteItem`,
  historyConfirmPop: `history.confirmPop`,

  // http
  request: `http.request`,

  // serviceHub
  serviceHubGetAllServices: 'zmGetAllServices',
  serviceHubQueryAllSkills: 'zmQueryAllSkills',
  serviceHubAddEventListener: 'zmAddEventListener',
  serviceHubExecuteAction: 'zmExecuteAction',

  // mobile
  getSafeArea: `mobile.getSafeArea`,
  setNavigationBarConfig: `mobile.setNavigationBarConfig`,
  setSubNavigationConfig: `mobile.setSubNavigationConfig`,
  setDetailNavigationBarConfig: `mobile.setDetailNavigationBarConfig`,
  setSelectedSubNavigationItem: `mobile.setSelectedSubNavigationItem`,
  updateSubNavigationItem: `mobile.updateSubNavigationItem`,
  insertSubNavigationItem: `mobile.insertSubNavigationItem`,
  removeSubNavigationItem: `mobile.removeSubNavigationItem`,
  setFloatingActionButtonConfig: `mobile.setFloatingActionButtonConfig`,
  activeSearch: `mobile.activeSearch`,
  cancelSearch: `mobile.cancelSearch`,
  getKeyboardRect: `mobile.getKeyboardRect`,
  showKeyboard: `mobile.showKeyboard`,
  getShareCapabilities: `mobile.getShareCapabilities`,
  shareContent: `mobile.shareContent`,
  saveImageToAlbum: `mobile.saveImageToAlbum`,

  jsServiceResponse: 'zmSetJsServiceResponse',
  jsServiceRegister: 'zmRegisterJsService',
  jsServiceUnregister: 'zmUnregisterJsService',
  jsServiceNotifyListeners: 'zmNotifyListeners',
  cancelStreamingResponse: 'serviceHub.cancelStreamingResponse',
};

export default API;
